import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://rmplomberiechauffagevmc.com";

function upsertMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO({ title, description, keywords, image }) {
  const { pathname } = useLocation();
  const url = `${SITE}${pathname}`;
  const fullTitle = title;
  const ogImage = image || `${SITE}/logo-rm.jpg`;

  useEffect(() => {
    if (fullTitle) document.title = fullTitle;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);

    // Canonical
    upsertLink("canonical", url);

    // Open Graph
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:locale", "fr_FR");
    upsertMeta("property", "og:site_name", "RM Plomberie Chauffage VMC");

    // Twitter Card
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);
  }, [fullTitle, description, keywords, url, ogImage]);

  return null;
}
